function isMouseEvent(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

export { isMouseEvent, isTouchEvent };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/gestures/utils/event-type.js
// module id = 55
// module chunks = 0